import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "core/authentication.service";
import { MainService } from "core/main.service";
import { Observable } from "rxjs";
import { VersionCheckUpdateHintComponent } from "navigation/version-check-update-hint/version-check-update-hint.component";
import { AsyncPipe } from "@angular/common";
import { UserImageComponent } from "common/user-image.component";
import { TranslateModule } from "@ngx-translate/core";
import { State } from "core/volatile-application-state.model";

@Component({
	selector: "stages-support-section",
	templateUrl: "./support-section.component.html",
	imports: [VersionCheckUpdateHintComponent, UserImageComponent, TranslateModule, AsyncPipe],
})
export class SupportSectionComponent {
	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private authService = inject(AuthenticationService);
	private mainService = inject(MainService);

	appContext$: Observable<stages.context.ApplicationContext>;

	constructor() {
		this.appContext$ = this.mainService.applicationContext$;
	}

	logout(): void {
		this.authService.logout(null);
	}

	openSettings(): void {
		this.mainService.applicationState.navigationDrawerOpen = State.RESPONSIVE;
		this.router.navigate([{ outlets: { dialog: ["user", "settings"] } }], { relativeTo: this.route });
	}
}
